import type { Task } from "@gearbox-protocol/deploy-tools-shared";
import {
  CopyToClipboardButton,
  ErrorBox,
  Loading,
  OptimistReport,
  OptimistReportControls,
  OptimistReportProvider,
} from "@gearbox-protocol/deploy-tools-ui";
import {
  type ExecutionReport,
  TRACK_ROLES,
} from "@gearbox-protocol/liquidator-v2-config";
import { api } from "api";
import type { FC } from "react";
import { useSearchParams } from "react-router-dom";
import { useAsync } from "react-use";
import { useUnpausedForkStatus } from "../../context";

interface Props {
  task: Task;
}

export const TaskOptimist: FC<Props> = ({ task }) => {
  const {
    loading,
    error,
    value: report,
  } = useAsync(async () => {
    return api.fetchTaskArtifact<ExecutionReport>(task, "output.json");
  }, [task]);

  const { executionId, alias } = useUnpausedForkStatus();
  const [searchParams] = useSearchParams();
  const role = TRACK_ROLES.find(r => r === searchParams.get("role"));
  const permalink = window.location.href.replaceAll(
    alias ?? "???",
    executionId,
  );

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorBox error={error} />;
  }

  if (!report) {
    return <ErrorBox>Report not found</ErrorBox>;
  }

  return (
    <OptimistReportProvider
      report={report}
      traceFilesPath={`../../artifacts/view/${task.outputDir}`}
      initialRole={role}
    >
      <div className="flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4">
        <div className="flex flex-col gap-4">
          <div className="flex flex-row items-center justify-between">
            <h3>Optimist report</h3>
            <CopyToClipboardButton text={permalink} />
          </div>

          <OptimistReportControls />
        </div>

        <OptimistReport executionId={executionId} />
      </div>
    </OptimistReportProvider>
  );
};
